import React, { useEffect } from "react";
import CommonLayout from "../layout/CommonLayout";
import ButtonNavigation from "../components/ButtonNavigation";
import orderHistory from "../assets/images/icons/orderHistory.svg";
import signout from "../assets/images/icons/signOut.svg";
import goIcon from "../assets/images/icons/checkCouponArrow.svg";
import UseHeader from "../components/UserHeader";
import { useNavigate, useParams } from "react-router-dom";
import { getDomainInfo } from "../utils/utils";
import { useUser } from "../context/userContext";
import { CircularProgress } from "@mui/material";

function OrderHistoryandSignOut() {
  const { userId } = useParams();
  const { hostname, isPredefinedDomain, uid } = getDomainInfo(userId);
  const navigate = useNavigate();
    const { userData, fetchUserData } = useUser();

    useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      navigate(isPredefinedDomain ? `/${userId}/login` : "/login");
    }
  }, [navigate, userId]);

  const OrderHistoryHandeller = () => {
    navigate(
      isPredefinedDomain ? `/${uid}/order-history` : "/order-history"
    );
  };
  const SignoutHandeller = async() => {
    const token = localStorage.getItem("token");
    const cartContext = localStorage.getItem("cartContext");

    if (token !== null) {


        try {
              const response = await fetch(
                `${process.env.REACT_APP_BACKEND_URL}customer/signout`,
                {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                  },
                  body: JSON.stringify({
                    cartContext: cartContext,
                    storeId:userData?.id
                  }),
                }
              );
              const data = await response.json();
              if (response.ok) {

                if(data.cartContext){
                localStorage.setItem("cartContext", data?.cartContext);

                }
                              // localStorage.removeItem("cartContext");
      
            
              } else {
                console.log(
                  data.message || "Verification failed. Please try again."
                );
              }
            } catch (error) {
              console.log("An error occurred. Please try again later.");
            }
      localStorage.removeItem("token");
      localStorage.removeItem("usermob");
      localStorage.removeItem("customerId");

//  window.location.reload()


      navigate(isPredefinedDomain ? `/${uid}/login` : "/login");
    }
  };
  return (
    <CommonLayout>
      <div className="order-status-sec rootCommonBox">
                    <div className="customCardBox" style={{background:'#eee' }}>
      <UseHeader />
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          padding: "10px 20px",
          paddingTop: "30px",
          gap: "12px",
        }}
      >
       {userData?<React.Fragment>
       
        <ButtonNavigation
          className={"orderHistoryButton"}
          onClick={OrderHistoryHandeller}
          name={"Order History"}
          icon1={orderHistory}
          icon2={goIcon}
        />
        <ButtonNavigation

        
          onClick={SignoutHandeller}
          name={"Sign out"}
          icon1={signout}
          icon2={goIcon}
        /></React.Fragment>:<CircularProgress />}
      </div>
      </div>
      </div>
    </CommonLayout>
  );
}

export default OrderHistoryandSignOut;
